import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        loading: false
    },

    getters: {
        loading: state => state.loading
    },

    mutations: {
        startLoading(state) {
            state.loading = true;
        },

        stopLoading() {
            state.loading = false;
        }
    }
});